import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.1992 4.00078C13.1992 3.33804 12.662 2.80078 11.9992 2.80078C11.3365 2.80078 10.7992 3.33804 10.7992 4.00078L10.7992 10.8008H4.00078C3.33804 10.8008 2.80078 11.338 2.80078 12.0008C2.80078 12.6635 3.33804 13.2008 4.00078 13.2008H10.7992L10.7992 20.0008C10.7992 20.6635 11.3365 21.2008 11.9992 21.2008C12.662 21.2008 13.1992 20.6635 13.1992 20.0008V13.2008H20.0008C20.6635 13.2008 21.2008 12.6635 21.2008 12.0008C21.2008 11.338 20.6635 10.8008 20.0008 10.8008H13.1992V4.00078Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconPlusFill = forwardRef(Icon);
export default IconPlusFill;
